import { FunctionComponent } from 'react';
import { Box, TextField, TextFieldProps } from '@mui/material';
import { FlexContainer } from '@/components/Layout/Container';

const isValidHexColor = (value: unknown): value is string =>
    typeof value === 'string' && /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(value);

export const ColorInput: FunctionComponent<TextFieldProps> = (props) => {
    return (
        <FlexContainer
            sx={{
                alignItems: 'center',
                width: '100%',
            }}
        >
            <TextField
                sx={{
                    display: 'flex',
                    flexGrow: 1,
                }}
                {...props}
            />
            <Box
                component='input'
                type='color'
                disabled={props.disabled}
                value={isValidHexColor(props.value) ? props.value : '#ffffff'}
                onChange={props.onChange}
                sx={(theme) => ({
                    ml: 2,
                    width: '48px',
                    height: '48px',
                    p: 0,
                    border: `1px solid ${theme.palette.grey[200]}`,
                    borderRadius: 1,
                    cursor: props.disabled ? 'default' : 'pointer',
                    backgroundColor: 'transparent',
                    '&::-webkit-color-swatch-wrapper': {
                        p: 0,
                    },
                    '&::-webkit-color-swatch': {
                        border: 'none',
                        borderRadius: 1,
                    },
                })}
            />
        </FlexContainer>
    );
};
